// indexedDbStorage.js
import { get, set, del, clear } from "idb-keyval";

const indexedDbStorage = {
  getItem: async (key) => {
    const value = await get(key);
    return value === undefined ? null : JSON.stringify(value);
  },
  setItem: async (key, value) => {
    await set(key, JSON.parse(value));
  },
  removeItem: async (key) => {
    await del(key);
  },
  clearAll: async () => {
    await clear();
  },

  // ✅ NEW
  saveSnapshot: async (snapshot) => {
    await set("snapshot", snapshot);
  },
  loadSnapshot: async () => {
    const value = await get("snapshot");
    return value ?? null;
  },
};

export default indexedDbStorage;